























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import firebase from '@/plugins/firebase';
import { Project, Collection } from '@/types';
import { getModule } from 'vuex-module-decorators';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import Admin from '@/store/modules/admin';
import store from '@/store/store';
import { mapState } from 'vuex';
import { isValidUrl } from '@/plugins/utils';

const db = firebase.firestore();

@Component
export default class Entries extends Vue {
  adminModule = getModule(Admin, this.$store);
  dialog = false;

  manifestDialog = false;
  manifestImportDialog = false;
  manifestUrls = '';
  manifestImportProgress = 0;
  manifestImportList: string[] = [];
  manifestImportLogs = [];

  newCollection: Collection = this.createCollection();
  selectedCollection: Collection = this.createCollection();
  tempCollection: Collection = this.createCollection();
  headers = [
    { text: 'サムネイル', sortable: false, value: 'thumbnail' },
    { text: 'タイトル/所蔵', sortable: false, value: 'label' },
    /* { text: '所蔵', sortable: false, value: 'label' }, */
    { text: 'サイズ', sortable: false, value: 'size' },
    { text: 'アクション', sortable: false, value: 'size' },
  ];

  editCollectionDialog = false;

  // remove entry
  removeEntryPrompt = false;
  removeEntryId = '';

  get manifestImportProgressMsg() {
    return `${this.manifestImportProgress}/${this.manifestImportList.length}`;
  }

  get entries() {
    return this.adminModule.entries || [];
  }

  get collections() {
    return this.adminModule.collections;
  }

  get project() {
    return this.adminModule.project;
  }

  created() {
    this.adminModule.unbindEntries();
  }

  createCollection(): Collection {
    return { title: '', description: '', entryCount: 0 };
  }

  openEditCollectionDialog() {
    this.editCollectionDialog = true;
    this.tempCollection = Object.assign({}, this.selectedCollection);
  }

  closeCollectionDialog() {
    this.dialog = false;
    this.newCollection = this.createCollection();
  }

  closeEditCollectionDialog() {
    this.editCollectionDialog = false;
  }

  confirmRemoveEntry(entryId: string) {
    this.removeEntryId = entryId;
    this.removeEntryPrompt = true;
  }

  removeEntry() {
    this.adminModule.removeEntry({ entryId: this.removeEntryId });
    this.removeEntryPrompt = false;
  }

  addCollection() {
    this.dialog = false;
    this.adminModule.addCollection(this.newCollection);
  }

  async updateCollection() {
    await this.adminModule.updateCollection({
      id: this.selectedCollection.id || '',
      collection: this.tempCollection,
    });
    this.editCollectionDialog = false;
  }

  onCollectionSelected() {
    this.adminModule.bindEntries(this.selectedCollection.id || '');
  }

  validateManifests(): boolean {
    let valid = true;
    if (this.manifestImportList.length == 0) return false;
    this.manifestImportList.forEach((url) => {
      if (!isValidUrl(url)) valid = false;
    });
    return valid;
  }

  async startImportingManifests() {
    this.manifestImportProgress = 0;
    this.manifestImportDialog = true;
    this.manifestImportList = this.manifestUrls.split('\n');
    if (!this.validateManifests()) return;
    this.manifestImportProgress = 0;
    await Promise.all(
      this.manifestImportList.map((url) => {
        this.manifestImportProgress += 1;
        return this.adminModule.importManifest({
          projectId: this.project.id,
          collectionId: this.selectedCollection.id || '',
          manifestUrl: url,
        });
      }),
    );
    this.manifestDialog = false;
    this.manifestImportDialog = false;
    this.manifestUrls = '';
  }
}
